import _assertThisInitialized from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { constructStack } from "@smithy/middleware-stack";
import { SMITHY_CONTEXT_KEY } from "@smithy/types";
export var Command = /*#__PURE__*/function () {
  function Command() {
    _classCallCheck(this, Command);
    this.middlewareStack = constructStack();
  }
  _createClass(Command, [{
    key: "resolveMiddlewareWithContext",
    value: function resolveMiddlewareWithContext(clientStack, configuration, options, _ref) {
      var middlewareFn = _ref.middlewareFn,
        clientName = _ref.clientName,
        commandName = _ref.commandName,
        inputFilterSensitiveLog = _ref.inputFilterSensitiveLog,
        outputFilterSensitiveLog = _ref.outputFilterSensitiveLog,
        smithyContext = _ref.smithyContext,
        additionalContext = _ref.additionalContext,
        CommandCtor = _ref.CommandCtor;
      var _iterator = _createForOfIteratorHelper(middlewareFn.bind(this)(CommandCtor, clientStack, configuration, options)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mw = _step.value;
          this.middlewareStack.use(mw);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var stack = clientStack.concat(this.middlewareStack);
      var logger = configuration.logger;
      var handlerExecutionContext = _objectSpread(_defineProperty({
        logger: logger,
        clientName: clientName,
        commandName: commandName,
        inputFilterSensitiveLog: inputFilterSensitiveLog,
        outputFilterSensitiveLog: outputFilterSensitiveLog
      }, SMITHY_CONTEXT_KEY, _objectSpread({
        commandInstance: this
      }, smithyContext)), additionalContext);
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function (request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    }
  }], [{
    key: "classBuilder",
    value: function classBuilder() {
      return new ClassBuilder();
    }
  }]);
  return Command;
}();
var ClassBuilder = /*#__PURE__*/function () {
  function ClassBuilder() {
    _classCallCheck(this, ClassBuilder);
    this._init = function () {};
    this._ep = {};
    this._middlewareFn = function () {
      return [];
    };
    this._commandName = "";
    this._clientName = "";
    this._additionalContext = {};
    this._smithyContext = {};
    this._inputFilterSensitiveLog = function (_) {
      return _;
    };
    this._outputFilterSensitiveLog = function (_) {
      return _;
    };
    this._serializer = null;
    this._deserializer = null;
  }
  _createClass(ClassBuilder, [{
    key: "init",
    value: function init(cb) {
      this._init = cb;
    }
  }, {
    key: "ep",
    value: function ep(endpointParameterInstructions) {
      this._ep = endpointParameterInstructions;
      return this;
    }
  }, {
    key: "m",
    value: function m(middlewareSupplier) {
      this._middlewareFn = middlewareSupplier;
      return this;
    }
  }, {
    key: "s",
    value: function s(service, operation) {
      var smithyContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this._smithyContext = _objectSpread({
        service: service,
        operation: operation
      }, smithyContext);
      return this;
    }
  }, {
    key: "c",
    value: function c() {
      var additionalContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._additionalContext = additionalContext;
      return this;
    }
  }, {
    key: "n",
    value: function n(clientName, commandName) {
      this._clientName = clientName;
      this._commandName = commandName;
      return this;
    }
  }, {
    key: "f",
    value: function f() {
      var inputFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_) {
        return _;
      };
      var outputFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_) {
        return _;
      };
      this._inputFilterSensitiveLog = inputFilter;
      this._outputFilterSensitiveLog = outputFilter;
      return this;
    }
  }, {
    key: "ser",
    value: function ser(serializer) {
      this._serializer = serializer;
      return this;
    }
  }, {
    key: "de",
    value: function de(deserializer) {
      this._deserializer = deserializer;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      var closure = this;
      var _CommandRef;
      return _CommandRef = /*#__PURE__*/function (_Command) {
        _inherits(CommandRef, _Command);
        var _super = _createSuper(CommandRef);
        function CommandRef() {
          var _this;
          for (var _len = arguments.length, _ref2 = new Array(_len), _key = 0; _key < _len; _key++) {
            _ref2[_key] = arguments[_key];
          }
          var input = _ref2[0];
          _classCallCheck(this, CommandRef);
          _this = _super.call(this);
          _this.serialize = closure._serializer;
          _this.deserialize = closure._deserializer;
          _this.input = input !== null && input !== void 0 ? input : {};
          closure._init(_assertThisInitialized(_this));
          return _this;
        }
        _createClass(CommandRef, [{
          key: "resolveMiddleware",
          value: function resolveMiddleware(stack, configuration, options) {
            return this.resolveMiddlewareWithContext(stack, configuration, options, {
              CommandCtor: _CommandRef,
              middlewareFn: closure._middlewareFn,
              clientName: closure._clientName,
              commandName: closure._commandName,
              inputFilterSensitiveLog: closure._inputFilterSensitiveLog,
              outputFilterSensitiveLog: closure._outputFilterSensitiveLog,
              smithyContext: closure._smithyContext,
              additionalContext: closure._additionalContext
            });
          }
        }], [{
          key: "getEndpointParameterInstructions",
          value: function getEndpointParameterInstructions() {
            return closure._ep;
          }
        }]);
        return CommandRef;
      }(Command);
    }
  }]);
  return ClassBuilder;
}();